export default "__VITE_ASSET__ccc0af8c__"